// {
//   "name": "iconic-video-product-first.js",
//   "author": "Arham Web Works"
//   "description": "Copying in any form is strictly prohibited. Any instance of copying will be subject to legal action and accountability under the law."
// }

(() => {
  if (customElements.get('play-pause-button-product')) {
    return;
  }

  class PlayPauseButtonProduct extends HTMLElement {
    constructor() {
      super();
      this.video = null;
      this.playButton = null;
      this.pauseButton = null;

      this.togglePlayPause = this.togglePlayPause.bind(this);
    }

    connectedCallback() {
      this.init();
    }

    init() {
      // Find the closest video container
      const videoWrapper = this.closest('.iconic-video-product-first');
      if (!videoWrapper) {
        console.error('No parent .iconic-video-product-first found for play-pause-button.');
        return;
      }

      this.video = videoWrapper.querySelector('.iconic-video');
      this.playButton = this.querySelector('.iconic-play');
      this.pauseButton = this.querySelector('.iconic-pause');

      if (!this.video || !this.playButton || !this.pauseButton) {
        console.error('Missing video or play/pause buttons in play-pause-button.');
        return;
      }

      this.playButton.addEventListener('click', this.togglePlayPause);
      this.pauseButton.addEventListener('click', this.togglePlayPause);

      // Ensure correct button visibility on video end
      this.video.addEventListener('ended', () => {
        this.updateButtonState(false);
      });
    }

    togglePlayPause() {
      if (this.video.paused) {
        this.video.play();
        this.updateButtonState(true);
      } else {
        this.video.pause();
        this.updateButtonState(false);
      }
    }

    updateButtonState(isPlaying) {
      if (isPlaying) {
        this.playButton.classList.add('iconic-d-none');
        this.pauseButton.classList.remove('iconic-d-none');
      } else {
        this.pauseButton.classList.add('iconic-d-none');
        this.playButton.classList.remove('iconic-d-none');
      }
    }
  }

  customElements.define('play-pause-button-product', PlayPauseButtonProduct);
})();